// Configurações → Integrações: saídas do sistema — servidor de e-mail (SMTP), Asana, destinatários do status semanal,
// limites de cor de cada área e grupos (número/LID da instância para reconhecer menções). Permissão: integracoes.gerenciar.
// Senha do SMTP e token do Asana ficam cifrados no servidor e nunca voltam para a tela (só "definido").
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Accordion, AccordionDetails, AccordionSummary, Button, Chip, FormControlLabel, MenuItem, Paper, Switch, TextField, Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import suporteApi, { mensagemErro } from "./api";
import { dataBR } from "./comum";

const NOMES = { ALARME: "Suporte Alarme/CFTV/Acesso", COFRES: "Suporte Cofres/Guarda-volumes/Portas", CONTRATACAO: "Contratação",
  SUPERVISAO: "Supervisão de campo", DOCUMENTACAO: "Documentação e Treinamento", SATISFACAO: "Pesquisa de satisfação", CHATBOT: "Chatbot" };
const LIMITES = {
  no_prazo_min_pct: "No prazo mínimo (%)", primeira_resposta_max_min: "1ª resposta máxima (min)", retornos_max_pct: "Retornos máximo (%)",
  formularios_parados_max: "Formulários parados > 24 h (máx.)", pendentes_parados_max: "Cards pendentes parados (máx.)",
  dias_na_etapa_max: "Dias na mesma etapa (máx.)", candidatos_parados_max: "Candidatos parados (máx.)", documentos_vencidos_max: "Documentos vencidos (máx.)",
  realizadas_min_pct: "Visitas realizadas mínimo (%)", apontamentos_criticos_vencidos_max: "Apontamentos críticos vencidos (máx.)",
  apontamentos_vencidos_max: "Apontamentos vencidos (máx.)", revisoes_vencidas_max: "Revisões de manual vencidas (máx.)",
  feedbacks_parados_max: "Feedbacks parados > 7 dias (máx.)", nota_media_min: "Nota média mínima", resolvido_min_pct: "Resolvido mínimo (%)",
  criticas_sem_tratamento_max: "Críticas sem tratamento (máx.)", conclusao_min_pct: "Conclusão mínima (%)", falhas_envio_max: "Falhas de envio (máx.)",
};
const lista = (t) => String(t || "").split(/[\s,;]+/).map((x) => x.trim()).filter(Boolean);
const Definido = ({ ok, rotulo }) => <Chip size="small" label={ok ? `${rotulo} definido` : `${rotulo} não definido`}
  style={{ background: ok ? "#e8f5e9" : "#fff3e0" }} />;

const Secao = ({ titulo, resumo, children }) => (
  <Accordion variant="outlined" style={{ marginTop: 8 }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant="subtitle1" style={{ flex: 1 }}><b>{titulo}</b></Typography>
      <Typography variant="caption" color="textSecondary" style={{ alignSelf: "center" }}>{resumo}</Typography>
    </AccordionSummary>
    <AccordionDetails style={{ display: "block" }}>{children}</AccordionDetails>
  </Accordion>
);

const Smtp = ({ c, recarregar }) => {
  const v = c.valor || {};
  const [f, setF] = useState({ host: v.host || "", porta: v.porta || 587, seguranca: v.seguranca || "starttls", usuario: v.usuario || "",
    senha: "", remetente_nome: v.remetente_nome || "Central de Suporte Allarmi", remetente_email: v.remetente_email || "", responder_para: v.responder_para || "" });
  const [teste, setTeste] = useState("");
  const salvar = async () => {
    try {
      await suporteApi.put("/api/integracoes/smtp", { ...f, porta: Number(f.porta), senha: f.senha || null });
      toast.success("E-mail salvo");
      setF({ ...f, senha: "" });
      recarregar();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const testar = async () => {
    try {
      await suporteApi.post("/api/integracoes/smtp/teste", { para: teste });
      toast.success(`E-mail de teste enviado para ${teste}`);
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const campo = (k, rotulo, extra = {}) => <TextField id={`smtp-${k}`} size="small" variant="outlined" margin="dense" label={rotulo}
    value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} {...extra} />;
  return (
    <Secao titulo="Servidor de e-mail (SMTP)" resumo={v.host ? `${v.host}:${v.porta} · ${v.remetente_email}` : "não configurado"}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {campo("host", "Servidor", { style: { minWidth: 240 } })}
        {campo("porta", "Porta", { type: "number", style: { width: 100 } })}
        <TextField id="smtp-seg" select size="small" variant="outlined" margin="dense" label="Segurança" value={f.seguranca}
          onChange={(e) => setF({ ...f, seguranca: e.target.value })} style={{ width: 140 }}>
          <MenuItem value="starttls">STARTTLS</MenuItem><MenuItem value="ssl">SSL/TLS</MenuItem><MenuItem value="nenhuma">Nenhuma</MenuItem>
        </TextField>
        {campo("usuario", "Usuário")}
        {campo("senha", "Senha (deixe em branco para manter)", { type: "password" })}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {campo("remetente_nome", "Nome do remetente")}
        {campo("remetente_email", "E-mail do remetente")}
        {campo("responder_para", "Responder para (opcional)")}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6, flexWrap: "wrap" }}>
        <Definido ok={c.segredo_definido} rotulo="Senha" />
        <Button size="small" variant="contained" color="primary" onClick={salvar}>Salvar</Button>
        <TextField id="smtp-teste" size="small" variant="outlined" placeholder="e-mail para teste" value={teste} onChange={(e) => setTeste(e.target.value)} />
        <Button size="small" variant="outlined" disabled={!teste.includes("@")} onClick={testar}>Enviar teste</Button>
      </div>
    </Secao>
  );
};

const Asana = ({ c, recarregar }) => {
  const v = c.valor || {};
  const [f, setF] = useState({ token: "", workspace: v.workspace || "", projeto_teste: v.projeto_teste || "", modo_teste: v.modo_teste ?? true,
    relatorio_semanal: v.relatorio_semanal ?? true, anexar_excel: v.anexar_excel ?? true, projetos: v.projetos || {} });
  const [conta, setConta] = useState(null);
  const salvar = async () => {
    try {
      await suporteApi.put("/api/integracoes/asana", { ...f, token: f.token || null });
      toast.success("Asana salvo");
      setF({ ...f, token: "" });
      recarregar();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const testar = async () => {
    try {
      setConta((await suporteApi.post("/api/integracoes/asana/teste")).data);
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  return (
    <Secao titulo="Asana" resumo={`${c.segredo_definido ? "token definido" : "sem token"} · ${v.modo_teste === false ? "publicando de verdade" : "modo de teste"}`}>
      <Typography variant="caption" color="textSecondary" component="div">
        Toda semana: status update em cada projeto de área e, nas áreas de suporte, a tarefa “Relatório semanal de atendimentos”
        com comparativo e Excel. Use o token de uma <b>conta de serviço</b>. Em modo de teste, tudo vai só para o projeto de teste.
      </Typography>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        <TextField id="asana-token" size="small" variant="outlined" margin="dense" type="password" label="Token (em branco mantém)"
          value={f.token} onChange={(e) => setF({ ...f, token: e.target.value })} />
        <TextField id="asana-ws" size="small" variant="outlined" margin="dense" label="Workspace (gid)" value={f.workspace}
          onChange={(e) => setF({ ...f, workspace: e.target.value })} />
        <TextField id="asana-teste" size="small" variant="outlined" margin="dense" label="Projeto de teste (gid)" value={f.projeto_teste}
          onChange={(e) => setF({ ...f, projeto_teste: e.target.value })} />
      </div>
      <FormControlLabel control={<Switch color="primary" checked={f.modo_teste} onChange={(e) => setF({ ...f, modo_teste: e.target.checked })} />} label="Modo de teste" />
      <FormControlLabel control={<Switch color="primary" checked={f.relatorio_semanal} onChange={(e) => setF({ ...f, relatorio_semanal: e.target.checked })} />} label="Criar tarefa com o relatório semanal de atendimentos" />
      <FormControlLabel control={<Switch color="primary" checked={f.anexar_excel} onChange={(e) => setF({ ...f, anexar_excel: e.target.checked })} />} label="Anexar o Excel" />
      <Typography variant="subtitle2" style={{ marginTop: 6 }}>Projeto de cada área (gid)</Typography>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 6 }}>
        {Object.keys(NOMES).map((a) => (
          <TextField key={a} id={`asana-${a}`} size="small" variant="outlined" label={NOMES[a]} value={f.projetos[a] || ""}
            onChange={(e) => setF({ ...f, projetos: { ...f.projetos, [a]: e.target.value } })} />
        ))}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}>
        <Definido ok={c.segredo_definido} rotulo="Token" />
        <Button size="small" variant="contained" color="primary" onClick={salvar}>Salvar</Button>
        <Button size="small" variant="outlined" disabled={!c.segredo_definido} onClick={testar}>Testar conexão</Button>
        {conta && <Typography variant="caption">Conectado como {conta.usuario} ({conta.email}) · workspaces: {conta.workspaces.map((w) => `${w.nome} (${w.gid})`).join(", ")}</Typography>}
      </div>
    </Secao>
  );
};

const Destinatarios = ({ c, recarregar }) => {
  const v = c.valor || {};
  const [f, setF] = useState({ ativo: v.ativo ?? false, modo_teste: v.modo_teste ?? true, teste_para: (v.teste_para || []).join(", "),
    consolidado: (v.consolidado || []).join(", "), dia_semana: v.dia_semana || 1, hora: v.hora || "08:00", link_painel: v.link_painel || "",
    areas: Object.fromEntries(Object.keys(NOMES).map((a) => [a, ((v.areas || {})[a] || []).join(", ")])) });
  const salvar = async () => {
    try {
      await suporteApi.put("/api/integracoes/destinatarios", {
        ...f, dia_semana: Number(f.dia_semana), teste_para: lista(f.teste_para), consolidado: lista(f.consolidado),
        areas: Object.fromEntries(Object.entries(f.areas).map(([a, t]) => [a, lista(t)]).filter(([, l]) => l.length)),
      });
      toast.success("Destinatários salvos");
      recarregar();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const dias = ["", "segunda", "terça", "quarta", "quinta", "sexta", "sábado", "domingo"];
  return (
    <Secao titulo="E-mail semanal — destinatários" resumo={v.ativo ? `${dias[v.dia_semana || 1]} ${v.hora || "08:00"} · ${v.modo_teste === false ? "envio real" : "modo de teste"}` : "desligado"}>
      <FormControlLabel control={<Switch color="primary" checked={f.ativo} onChange={(e) => setF({ ...f, ativo: e.target.checked })} />} label="Envio automático ligado" />
      <FormControlLabel control={<Switch color="primary" checked={f.modo_teste} onChange={(e) => setF({ ...f, modo_teste: e.target.checked })} />} label="Modo de teste (tudo só para quem testa)" />
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        <TextField id="dest-teste" size="small" variant="outlined" margin="dense" label="E-mails de teste" value={f.teste_para}
          onChange={(e) => setF({ ...f, teste_para: e.target.value })} style={{ minWidth: 300 }} />
        <TextField id="dest-dia" select size="small" variant="outlined" margin="dense" label="Dia" value={f.dia_semana}
          onChange={(e) => setF({ ...f, dia_semana: e.target.value })} style={{ width: 130 }}>
          {[1, 2, 3, 4, 5, 6, 7].map((d) => <MenuItem key={d} value={d}>{dias[d]}</MenuItem>)}
        </TextField>
        <TextField id="dest-hora" size="small" variant="outlined" margin="dense" label="Hora" value={f.hora}
          onChange={(e) => setF({ ...f, hora: e.target.value })} style={{ width: 90 }} />
        <TextField id="dest-link" size="small" variant="outlined" margin="dense" label="Link do painel/BI nos e-mails" value={f.link_painel}
          onChange={(e) => setF({ ...f, link_painel: e.target.value })} style={{ minWidth: 300 }} />
      </div>
      <TextField id="dest-consolidado" size="small" variant="outlined" margin="dense" fullWidth label="Consolidado (gestão) — e-mails separados por vírgula"
        value={f.consolidado} onChange={(e) => setF({ ...f, consolidado: e.target.value })} />
      {Object.keys(NOMES).map((a) => (
        <TextField key={a} id={`dest-${a}`} size="small" variant="outlined" margin="dense" fullWidth label={NOMES[a]}
          value={f.areas[a]} onChange={(e) => setF({ ...f, areas: { ...f.areas, [a]: e.target.value } })} />
      ))}
      <Button size="small" variant="contained" color="primary" onClick={salvar} style={{ marginTop: 6 }}>Salvar</Button>
    </Secao>
  );
};

const Limites = ({ limites, recarregar }) => {
  const [f, setF] = useState(limites);
  useEffect(() => setF(limites), [limites]);
  const salvar = async () => {
    try {
      const num = Object.fromEntries(Object.entries(f).map(([a, l]) => [a, Object.fromEntries(Object.entries(l).map(([k, x]) => [k, Number(x)]))]));
      await suporteApi.put("/api/integracoes/limites", { limites: num });
      toast.success("Limites salvos");
      recarregar();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  return (
    <Secao titulo="Limites de cor das áreas" resumo="nenhum fora = No prazo · 1 = Em risco · 2 ou mais = Fora do prazo">
      {Object.entries(f).map(([a, l]) => (
        <div key={a} style={{ marginBottom: 8 }}>
          <Typography variant="subtitle2">{NOMES[a] || a}</Typography>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {Object.entries(l).map(([k, x]) => (
              <TextField key={k} id={`lim-${a}-${k}`} size="small" variant="outlined" type="number" label={LIMITES[k] || k} value={x}
                onChange={(e) => setF({ ...f, [a]: { ...l, [k]: e.target.value } })} style={{ width: 240 }} />
            ))}
          </div>
        </div>
      ))}
      <Button size="small" variant="contained" color="primary" onClick={salvar}>Salvar</Button>
    </Secao>
  );
};

const GruposConfig = () => {
  const [g, setG] = useState(null);
  const [ids, setIds] = useState("");
  const carregar = useCallback(() => suporteApi.get("/api/integracoes/grupos").then((r) => {
    setG(r.data);
    setIds((r.data.identificadores || []).join(", "));
  }).catch((e) => toast.error(mensagemErro(e))), []);
  useEffect(() => { carregar(); }, [carregar]);
  if (!g) return null;
  const salvar = async (extra = {}) => {
    try {
      await suporteApi.put("/api/integracoes/grupos", { identificadores: lista(ids), bot_responde_mencoes: !!g.bot_responde_mencoes,
        card_mencao: g.card_mencao !== false, avisar_celular_mencao: !!g.avisar_celular_mencao, ...extra });
      toast.success("Grupos salvo");
      carregar();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  return (
    <Secao titulo="Grupos e menções" resumo={`${(g.detectados || []).length} identificador(es) da instância`}>
      <Typography variant="caption" color="textSecondary" component="div">
        Nos grupos, a menção ao suporte aparece como @número ou @LID (identificador interno do WhatsApp). Os da conexão são lidos
        automaticamente da sessão; complete aqui se precisar.
      </Typography>
      <Typography variant="body2" style={{ margin: "6px 0" }}>Detectados: {(g.detectados || []).join(", ") || "nenhum"}</Typography>
      <TextField id="grupos-ids" size="small" variant="outlined" fullWidth margin="dense" label="Identificadores extras (número com DDI ou LID)"
        value={ids} onChange={(e) => setIds(e.target.value)} />
      <FormControlLabel control={<Switch color="primary" checked={!!g.bot_responde_mencoes}
        onChange={(e) => { setG({ ...g, bot_responde_mencoes: e.target.checked }); salvar({ bot_responde_mencoes: e.target.checked }); }} />}
        label="Chatbot responde às menções (fluxo de grupo do Typebot)" />
      <FormControlLabel control={<Switch color="primary" checked={g.card_mencao !== false}
        onChange={(e) => { setG({ ...g, card_mencao: e.target.checked }); salvar({ card_mencao: e.target.checked }); }} />}
        label="Menção abre card para a tratativa (suporte, ou a fila da área do grupo)" />
      <FormControlLabel control={<Switch color="primary" checked={!!g.avisar_celular_mencao}
        onChange={(e) => { setG({ ...g, avisar_celular_mencao: e.target.checked }); salvar({ avisar_celular_mencao: e.target.checked }); }} />}
        label="Avisar no celular os usuários da área do grupo (quem tem celular cadastrado e avisos ligados)" />
      <div><Button size="small" variant="contained" color="primary" onClick={() => salvar()}>Salvar</Button></div>
    </Secao>
  );
};

const IntegracoesSaida = () => {
  const [d, setD] = useState(null);
  const carregar = useCallback(() => {
    suporteApi.get("/api/integracoes/config").then((r) => setD(r.data)).catch((e) => toast.error(mensagemErro(e)));
  }, []);
  useEffect(() => { carregar(); }, [carregar]);
  if (!d) return null;
  return (
    <Paper style={{ padding: 16, marginTop: 12 }}>
      <Typography variant="subtitle1"><b>E-mail, Asana e status semanal</b></Typography>
      <Typography variant="caption" color="textSecondary" component="div">
        Envio semanal dos relatórios por área (e-mail e Asana) e conexão com o servidor de e-mail. Prévia em Gestão → Status das áreas.
      </Typography>
      <Smtp key={`smtp-${d.smtp.atualizado_em}`} c={d.smtp} recarregar={carregar} />
      <Asana key={`asana-${d.asana.atualizado_em}`} c={d.asana} recarregar={carregar} />
      <Destinatarios key={`dest-${d.destinatarios.atualizado_em}`} c={d.destinatarios} recarregar={carregar} />
      <Limites limites={d.limites} recarregar={carregar} />
      <GruposConfig />
      {d.log.length > 0 && (
        <Secao titulo="Histórico de alterações" resumo={`${d.log.length} registro(s)`}>
          {d.log.map((l, i) => (
            <Typography key={i} variant="caption" component="div">{dataBR(l.criado_em)} · {l.usuario || "—"} · {l.tipo}: {l.acao}{l.detalhe ? ` (${l.detalhe})` : ""}</Typography>
          ))}
        </Secao>
      )}
    </Paper>
  );
};

export default IntegracoesSaida;
